<template>
  <Toast
    group="file-submission-processing"
    position="bottom-left"
    style="z-index: 1007"
  >
    <template #icon>
      <AppLoadingSpinner class="h-3 w-3 mt-[2px]" />
    </template>
  </Toast>
</template>

<script setup lang="ts">
import Toast from 'primevue/toast'
</script>
